import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';
import withLazyLoading from '../../hoc/withLazyLoading';

const SetPointConfigurationPage = withLazyLoading(
  () => import('../../pages/setPointConfiguration'),
);

const setPointConfigurationRoute = [
  {
    path: '/set-point-configuration',
    handle: createCrumbHandle('Set Point Configuration'),
    element: (
      <Suspense fallback={<Loader />}>
        <SetPointConfigurationPage />
      </Suspense>
    ),
    // No permission gate yet: validatePermission is FAIL-CLOSED (redirects to /authorizationFailed on an
    // unknown tag), so wiring it with a placeholder would lock out ALL users. Add the real loader only once
    // the backend ships the Set-Point permission tag: loader: validatePermission('<RealTag>').
  },
];

export default setPointConfigurationRoute;
